<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
    <h5 style="color:white; background:#112f4e;" class="px-3"><b>{{'EVALUATION_STUDY' |
            translate}}</b></h5>
    <p style="font-size:14px; margin-left:15px; margin-right:10px; color:black; text-align: justify;"><b>
        </b></p>
    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
        <b>{{'EVALUATION_ABOUT' | translate}}<br>
            {{'EVALUATION_OF_CADWM' | translate}}.</b>
    </p>
    <p><strong>{{'SUGGEST_GOV_INDIA' | translate}}:- </strong></p>

    <table class="w3-border" style="border-collapse:separate; margin-left:40px; width:90%;">
        <!-- <tr>
        <th>Sr.No.</th>
        <th>Name of Projects</th>
        <th>Physical Target(CCA in Ha.)</th>
        <th>
            Estimated cost of the Project(Rs. in lakh)</th>
        <th>Districts to be covered</th>
    </tr> -->
        <tr>
            <td>1.</td>
            <td>Chief Secretary to Govt. of Haryana</td>
            <td>Chairman</td>
        </tr>

        <tr>
            <td>2.</td>
            <td>Additional Chief Secretary/Principal Secretary,Agriculture Department.</td>
            <td>Vice Chairman</td>
        </tr>

        <tr>
            <td>3.</td>
            <td> Additional Chief Secretary/Principal Secretary,Finance & Planning Department</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>4.</td>
            <td>Additional Chief Secretary to Govt. Haryana, Development and Panchayat Department</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>5.</td>
            <td> Additional Chief Secretary/Principal Secretary,Water Resources/Irrigation/Minor Irrigation
                Department
            </td>
            <td>Member</td>
        </tr>

        <tr>
            <td>6.</td>
            <td>Additional Chief Secretary/Principal Secretary,to Govt. Haryana, Forest & Wildlife Department</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>7.</td>
            <td>Additional Chief Secretary/Principal Secretary,Science & Technology Department.</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>8.</td>
            <td>Additional Chief Secretary/Principal Secretary, Public Health Engineering Department.</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>9.</td>
            <td>Director General, Horticulture Haryana Panchkula</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>10.</td>
            <td>Director General/Director, Rural Development</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>11.</td>
            <td>Director General/Director, Science & Technology </td>
            <td>Member</td>
        </tr>

        <tr>
            <td>12.</td>
            <td>Representative of Department of Agriculture Co-operation &amp Farmers Welfare, Govt. of India</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>13.</td>
            <td>Representative Department of Water Resources &amp; GR, GOI</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>14.</td>
            <td>Representative Department of Land Resources &amp; Rural Development, GOI.</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>15.</td>
            <td>Principal Chief Conservator of Forests</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>16.</td>
            <td>Engineer-in-Chief, Public Health Engineering Department</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>17.</td>
            <td>Engineer-in-Chief, Irrigation &amp; Water Resources Department</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>18.</td>
            <td> Administrator, CADA</td>
            <td>Member</td>
        </tr>

        <tr>
            <td>19.</td>
            <td>Director General/Director, Agriculture</td>
            <td>Member Secretary</td>
        </tr>
    </table><br>
<!-- </div> -->